import useDefinedContext from "hooks/useDefinedContext";
import AreaChartActionsContext from "../contexts/AreaChartActionsContext";

interface UseAreaChartActionsProps {}

function useAreaChartActions(props?: UseAreaChartActionsProps) {
  return useDefinedContext(AreaChartActionsContext);
}

export default useAreaChartActions;
